import { render, staticRenderFns } from "./logEvent.vue?vue&type=template&id=070fbfe7"
import script from "./logEvent.vue?vue&type=script&lang=js"
export * from "./logEvent.vue?vue&type=script&lang=js"
import style0 from "./logEvent.vue?vue&type=style&index=0&id=070fbfe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports